import React from "react";
import SEO from "../SEO";
import config from "../../config";

const CAPABILITIES = [
  { title: "Monitor", desc: "Continuous scanning of public regulatory sources relevant to pharmaceutical and biotech manufacturing." },
  { title: "Distill", desc: "Filtering for genuine CMC relevance, not just keyword matches." },
  { title: "Index", desc: "Organizing findings by agency, domain, and program stage so the agent can find the right answer instantly." },
  { title: "Cite", desc: "Every answer links back to its original public source." },
];

const PRINCIPLES = [
  { num: "01", title: "Precision", desc: "CMC-specific tagging, not general regulatory-affairs summaries." },
  { num: "02", title: "Currency", desc: "Sources are checked continuously, not on a quarterly cycle." },
  { num: "03", title: "Independence", desc: "No paid relationships with the agencies or standards bodies we cover." },
  { num: "04", title: "Traceability", desc: "Every answer is sourced from a publicly available reference." },
];

export default function TheSeaAbout() {
  return (
    <>
    <SEO
      title="About askTheSea — CMC Regulatory Intelligence"
      description="Why we called it askTheSea: a direct way for CMC teams to ask public regulatory sources a question in plain language and get a sourced answer."
      url={`${config.BaseUrl}/about`}
      image={`${config.BaseUrl}/assets/logo.png?v=2`}
    />
    <section className="page active" id="page-about">
      <div className="wrap about-hero">
        <div className="eyebrow">About askTheSea</div>
        <h1>Why we called it askTheSea</h1>
        <div className="about-intro">
          <div>
            <p className="lede">Regulatory information behaves like open water: vast, always moving, and easy to lose your bearings in. A single agency can publish more in a month than one person can reasonably read, and CMC-relevant material is scattered across all of them.</p>
            <p>askTheSea exists to give CMC scientists a direct way to ask that water a question — in plain English — and get back an answer built only from what's publicly available, with the source quoted.</p>
            <p>We work exclusively from open sourced information. Nothing behind a login, nothing second-hand.</p>
          </div>
          <div className="coord-card">
            <div className="row"><span>Sources monitored</span><span>Public only</span></div>
            <div className="row"><span>Coverage focus</span><span>CMC</span></div>
            <div className="row"><span>Interface</span><span>Ask-anything chat</span></div>
            <div className="row"><span>Advisory scope</span><span>Intelligence, not legal advice</span></div>
            <div className="row"><span>Agencies tracked</span><span>ICH · FDA · EMA · PMDA · MHRA · WHO</span></div>
          </div>
        </div>
      </div>

      <div className="wrap">
        <section className="tight">
          <div className="section-head">
            <div className="eyebrow">What askTheSea do</div>
            <h2>Four steps, always in the open.</h2>
          </div>
          <div className="capability-grid">
            {CAPABILITIES.map((c) => (
              <div className="capability-card" key={c.title}>
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="tight">
          <div className="section-head">
            <div className="eyebrow">askTheSea Principles</div>
            <h2>What we hold ourselves to.</h2>
          </div>
          <div className="principles-list">
            {PRINCIPLES.map((p) => (
              <div className="principle" key={p.num}>
                <span className="tick">{p.num}</span>
                <div>
                  <h3>{p.title}</h3>
                  <p>{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </section>
    </>
  );
}
